import React from "react";
import {
  Box,
  Typography,
  Stack,
  Switch,
  FormControlLabel,
  Slider,
  TextField,
  MenuItem,
  Tooltip,
} from "@mui/material";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";
import { DRONE_STRATEGIES } from "../simulation/droneStrategies";

// Live autonomous-response settings: drone mode, deployment algorithm, density.
const ResponsePanel = ({
  droneModeActive,
  onDroneModeChange,
  strategyId,
  onStrategyChange,
  droneDensity,
  onDroneDensityChange,
  stationCount,
  disabled,
}) => {
  const strategy = DRONE_STRATEGIES[strategyId];
  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
        <SmartToyRoundedIcon fontSize="small" color="primary" />
        <Typography variant="subtitle2">Autonomous Response</Typography>
      </Stack>
      <FormControlLabel
        control={
          <Switch
            checked={droneModeActive}
            onChange={(e) => onDroneModeChange(e.target.checked)}
            color="primary"
          />
        }
        label={
          <Typography variant="body2">
            Drone Mode {droneModeActive && stationCount > 0 && `· ${stationCount} stations`}
          </Typography>
        }
      />
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
        Drones autonomously detect threatened assets and deploy retardant.
        Manual firefighting tools are disabled while active.
      </Typography>

      <TextField
        select
        fullWidth
        size="small"
        label="Deployment algorithm"
        value={strategyId}
        onChange={(e) => onStrategyChange(e.target.value)}
        sx={{ mb: 0.5 }}
      >
        {Object.entries(DRONE_STRATEGIES)
          .filter(([id]) => id !== "none")
          .map(([id, s]) => (
            <MenuItem key={id} value={id}>
              {s.name}
            </MenuItem>
          ))}
      </TextField>
      {strategy && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
          {strategy.description}
        </Typography>
      )}

      <Tooltip title="Higher density = more drone stations = faster response, higher infrastructure cost">
        <Box>
          <Typography variant="caption" color="text.secondary">
            Tower density
          </Typography>
          <Slider
            size="small"
            value={droneDensity}
            onChange={(_, v) => onDroneDensityChange(v)}
            min={1}
            max={10}
            step={1}
            marks
            valueLabelDisplay="auto"
            disabled={disabled}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};

export default ResponsePanel;
